import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { getAnalytics } from 'firebase/analytics'
import { getStorage } from 'firebase/storage'
import { NODE_ENV_DEVELOPMENT, FIREBASE_CONFIG, REGION } from '../../../pure-js/libs/Consts'
import config from '../Config'

export const app = initializeApp(FIREBASE_CONFIG)

export const analytics = config.enableAnalytics && getAnalytics(app)

export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  // Safari can stall Firestore WebChannel getDoc calls for ~30s then succeed. Auto-detect
  // falls back to long polling when the stream never establishes (measured on register SEO load).
  experimentalAutoDetectLongPolling: true
})

export const auth = getAuth(app)

export const functions = getFunctions(app, REGION)

export const storage = getStorage(app)

const getFunctionsEmulatorHost = (): string => {
  const envHost = import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST
  if (envHost) {
    return envHost
  }

  // On phone/simulator we need the LAN IP host, not localhost.
  return window.location.hostname || 'localhost'
}

// local development
if (process.env.NODE_ENV === NODE_ENV_DEVELOPMENT && import.meta.env.VITE_FUNCTIONS_LOCAL === 'true') {
  const functionsEmulatorHost = getFunctionsEmulatorHost()
  console.log('[LOCAL] Using functions from local emulator, needs "functions" folder started with "yarn serve"')
  console.log(`[LOCAL] Functions emulator host: ${functionsEmulatorHost}:5001`)
  connectFunctionsEmulator(functions, functionsEmulatorHost, 5001)
}
